import type {
  SearchTerminalContactsRequest,
  TerminalContactGetRequest,
} from '@trukt/tms-api/TerminalService';
import { createKey } from '../../createKey';

const keyHandler = createKey('terminal-contact');

export const TerminalContactServiceKeys = {
  key: keyHandler.key,
  getById: keyHandler.createMethod<TerminalContactGetRequest>(),
  search: keyHandler.createMethod<SearchTerminalContactsRequest>(),
};
